import React from "react";
import BookingPanel from "../../apartment-detail-view/components/BookingPanel";

const RoomBookingPanel = ({ room, onPriceChange, onDatesChange }) => {
  return (
    <BookingPanel
      apartment={room}
      onPriceChange={onPriceChange}
      onDatesChange={onDatesChange}
    />
  );
};

export default RoomBookingPanel;
